import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/dailysummary.css";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell
} from "recharts";

function DailySummary() {

  const token = localStorage.getItem("token");

  const [role, setRole] = useState("telesales");
  const [date, setDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [logs, setLogs] = useState([]);

  const [data, setData] = useState({
    meetings: "",
    sales: ""
  });

  const targets = {
    telesales: { calls: 100, sales: 150000, meetings: 0 },
    executive: { calls: 0, sales: 200000, meetings: 2 },
    manager: { calls: 0, sales: 200000, meetings: 2 }
  };

  const currentTarget = targets[role];

  const fetchLogs = async () => {
    try {
      const res = await axios.get("http://localhost:5000/api/calllogs", {
        headers: { Authorization: "Bearer " + token }
      });
      setLogs(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const todayCalls = logs.filter(log => {
    const logDate = new Date(log.call_date).toISOString().split("T")[0];
    return logDate === date;
  });

  const callCount = todayCalls.length;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // 📊 CHART DATA
  const barData = [
    { name: "Calls", value: callCount },
    { name: "Meetings", value: data.meetings || 0 },
    { name: "Sales", value: data.sales || 0 }
  ];

  const pieData = [
    { name: "Completed", value: callCount },
    { name: "Remaining", value: Math.max(currentTarget.calls - callCount, 0) }
  ];

  return (
    <div className="performance-page">

      {/* HEADER */}
      <div className="header-row">
        <h2>📊 Daily Performance</h2>

        <div className="filters">
          <input type="date" value={date} onChange={(e)=>setDate(e.target.value)} />

          <select value={role} onChange={(e)=>setRole(e.target.value)}>
            <option value="telesales">Telesales</option>
            <option value="executive">Sales Executive</option>
            <option value="manager">Sales Manager</option>
          </select>
        </div>
      </div>

      {/* INPUT */}
      <div className="input-box">
        {(role === "executive" || role === "manager") && (
          <input
            type="number"
            name="meetings"
            placeholder="Meetings Done"
            value={data.meetings}
            onChange={handleChange}
          />
        )}

        <input
          type="number"
          name="sales"
          placeholder="Sales Amount"
          value={data.sales}
          onChange={handleChange}
        />
      </div>

      {/* CARDS */}
      <div className="cards">

        <div className="card">
          <h4>📞 Calls</h4>
          <h2>{callCount}</h2>
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${(callCount / currentTarget.calls) * 100}%` }}
            />
          </div>
        </div>

        <div className="card">
          <h4>💰 Sales</h4>
          <h2>₹{data.sales || 0}</h2>
          <div className="progress-bar">
            <div
              className="progress sales"
              style={{ width: `${(data.sales / currentTarget.sales) * 100}%` }}
            />
          </div>
        </div>

        {(role !== "telesales") && (
          <div className="card">
            <h4>📅 Meetings</h4>
            <h2>{data.meetings || 0}</h2>
          </div>
        )}

      </div>

      {/* CHARTS */}
      <div className="charts">

        {/* BAR CHART */}
        <div className="chart-card">
          <h3>Performance Overview</h3>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={barData}>
              <Bar dataKey="value" radius={[10, 10, 0, 0]} />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* PIE CHART */}
        <div className="chart-card">
          <h3>Call Target</h3>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={pieData}
                dataKey="value"
                outerRadius={80}
                label
              >
                <Cell fill="#6366f1" />
<Cell fill="#22c55e" />
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

      </div>

    </div>
  );
}

export default DailySummary;